import React, { useState } from "react";
import axios from "axios";

const API = process.env.REACT_APP_BACKEND_URL;

export default function Stats() {
  const [code, setCode] = useState("");
  const [data, setData] = useState(null);
  const [error, setError] = useState("");

  const load = async (e) => {
    e.preventDefault();
    setError("");
    try {
      const res = await axios.get(`${API}/api/stats`, { params: { code } });
      setData(res.data);
    } catch {
      setError("Code invalide");
    }
  };

  return (
    <div className="min-h-screen bg-[#FDFBF7] pt-28 pb-20">
      <div className="max-w-3xl mx-auto px-6">
        <h1 className="font-display text-4xl text-[#12495B]">Statistiques du site</h1>
        {!data ? (
          <form onSubmit={load} className="mt-8 flex gap-3">
            <input
              type="password"
              value={code}
              onChange={(e) => setCode(e.target.value)}
              placeholder="Code d'accès"
              data-testid="stats-code-input"
              className="flex-1 rounded-full border border-slate-300 px-6 py-3"
            />
            <button type="submit" data-testid="stats-code-submit" className="rounded-full bg-[#12495B] text-white font-bold px-8 py-3">
              Voir
            </button>
          </form>
        ) : (
          <div className="mt-8 space-y-8" data-testid="stats-panel">
            <div className="grid grid-cols-2 gap-4">
              <div className="rounded-2xl bg-white border border-slate-200 p-6 text-center">
                <p className="text-4xl font-display text-[#12495B]" data-testid="stats-total-visiteurs">{data.total_visiteurs}</p>
                <p className="mt-1 text-sm font-semibold text-[#4B5563]">Visiteurs</p>
              </div>
              <div className="rounded-2xl bg-white border border-slate-200 p-6 text-center">
                <p className="text-4xl font-display text-[#12495B]" data-testid="stats-total-vues">{data.total_vues}</p>
                <p className="mt-1 text-sm font-semibold text-[#4B5563]">Pages vues</p>
              </div>
            </div>
            <div>
              <h2 className="font-display text-2xl text-[#12495B]">Par jour (30 derniers jours)</h2>
              <table className="mt-3 w-full text-sm">
                <thead><tr className="text-left text-[#4B5563]"><th className="py-2">Jour</th><th>Visiteurs</th><th>Pages vues</th></tr></thead>
                <tbody>
                  {data.par_jour.map((d) => (
                    <tr key={d.jour} className="border-t border-slate-200">
                      <td className="py-2 font-semibold text-[#12495B]">{d.jour}</td><td>{d.visiteurs}</td><td>{d.vues}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <div>
              <h2 className="font-display text-2xl text-[#12495B]">Pages les plus vues</h2>
              <table className="mt-3 w-full text-sm">
                <tbody>
                  {data.par_page.map((p) => (
                    <tr key={p.page} className="border-t border-slate-200">
                      <td className="py-2 font-semibold text-[#12495B]">{p.page}</td><td className="text-right">{p.vues}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        )}
        {error && <p className="mt-4 text-red-600 font-semibold" data-testid="stats-error">{error}</p>}
      </div>
    </div>
  );
}
